<template>
  <q-card>
    <q-toolbar class="bg-primary handle">
      <q-toolbar-title class="text-white">
        <q-icon
          v-if="icon"
          :name="icon"
          left
        />
        {{ title }}
      </q-toolbar-title>
      <slot name="header-side" />
    </q-toolbar>
    <slot name="section">
      <q-card-section>
        <slot>
          <q-list
            v-if="items.length"
            separator
          >
            <slot
              v-for="(item, i) in items"
              name="item"
              :item="item"
              :index="i"
            />
          </q-list>
          <q-item v-else>
            <q-item-section>
              <q-item-label>La liste est vide</q-item-label>
            </q-item-section>
          </q-item>
        </slot>
      </q-card-section>
    </slot>
    <q-inner-loading
      color="primary"
      :showing="loading"
    />
    <q-btn
      v-if="$listeners.ajouter || $slots.ajouter"
      round
      v-bind="mergedAddProps"
      class="absolute z-fab"
      style="top: 35px; right: 24px;"
      @click="$emit('ajouter')"
    >
      <slot name="ajouter" />
    </q-btn>
  </q-card>
</template>

<script>
export default {
  name: 'LwfCardList',
  props: {
    title: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    items: {
      type: Array,
      default: _.stubArray
    },
    loading: Boolean,
    addProps: {
      type: Object,
      default: _.stubObject
    }
  },
  computed: {
    mergedAddProps () {
      return {
        icon: 'fa fa-plus',
        color: 'secondary',
        ...this.addProps
      }
    }
  }
}
</script>

<style scoped>

</style>
